import { useHistory } from "react-router-dom";
import { Button } from "@material-ui/core";

import { BreadcrumbButtonProps } from "./breadcrumbs-button.props";
import { useBreadcrumbsButtonStyles } from "./breadcrumbs-button.styles";

export const BreadcrumbsButton = (props: BreadcrumbButtonProps) => {
  const classes = useBreadcrumbsButtonStyles();
  const history = useHistory();

  return (
    <Button
      className={classes.breadcrumbsButton}
      href={props.url}
      onClick={(e) => {
        e.preventDefault();
        history.push(props.url);
      }}
    >
      {props.title}
    </Button>
  );
};
